import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../styles/Social.css";
import axiosInstance from "../utils/axiosInstance";

export default function SocialPage() {
  const { t } = useTranslation("common");
  const navigate = useNavigate();

  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;

    async function fetchBrands() {
      setLoading(true);
      try {
        const { data } = await axiosInstance.get("/api/social/brands/");
        if (!alive) return;
        setBrands(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("brands fetch error:", err);
        if (!alive) return;
        setBrands([]);
      } finally {
        if (alive) setLoading(false);
      }
    }

    fetchBrands();

    return () => {
      alive = false;
    };
  }, []);

  return (
    <div className="social-page">
      <h1>{t("socialPage.title")}</h1>

      {loading ? (
        <div className="sf-empty">{t("socialPage.loadingBrands")}</div>
      ) : brands.length === 0 ? (
        <div className="sf-empty">{t("socialPage.noBrands")}</div>
      ) : (
        <div className="brand-grid">
          {brands.map((b) => (
            <div
              key={b.slug}
              className="brand-card"
              onClick={() => navigate(`/social/${b.slug}`)}
            >
              {b.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
